import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './tests.component.html',
  styleUrls: ['./tests.component.scss']
})
export class TestsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
